import {Component, OnInit} from '@angular/core';
import {ReportService} from './report.service';
import { ActivatedRoute } from '@angular/router';
import * as Highcharts from 'highcharts';
import HichartsExporting from 'highcharts/modules/exporting.src';
import HichartsExportingCSV from 'highcharts/modules/export-data.src';


HichartsExporting(Highcharts);
HichartsExportingCSV(Highcharts);

@Component({
  selector: 'app-reports',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {

  roomId: string;
  title = 'Reports';
  options: Object;
  reportStart: number;
  reportEnd: number;
  graphType = 'column';
  energySavings: any;
  savingsDataAvailable = false;
  reportDate: string;
  roomName = '';
  savingsDays = 1;
  automationHoursTotal = 0;
  energyUsedTotal = 0;
  energySavedTotal = 0;
  energySavedPercentage = 0;
  
  constructor(public route: ActivatedRoute, private reportService: ReportService) {
  }

  ngOnInit() {
    
    let dateNow = new Date();
    let year = dateNow.getFullYear();
    let month = dateNow.getMonth() - 1;
    
    let latestReportDate = new Date(year, month + 1, 1);
    this.reportDate = latestReportDate.toISOString().substr(0, 7);
    let reportStartDate = new Date(year, month, 1);
    this.reportStart = reportStartDate.getTime();
    let reportEndDate = new Date(year, month + 1, 1);
    this.reportEnd = reportEndDate.getTime();    

    this.roomId = this.route.snapshot.params.roomId;
    this.createGraph();
  }

  public onInput(yearMonth: Date): void {

    let dateArray = yearMonth.toString().split('-');
    let year = parseInt(dateArray[0], 10);
    let month = parseInt(dateArray[1], 10);
   
    let reportStartDate = new Date(year, month-1, 1);
    this.reportStart = reportStartDate.getTime();
    let reportEndDate = new Date(year, month, 1);
    this.reportEnd = reportEndDate.getTime();

 
    this.reportStart = Date.UTC(year, month - 1, 1);
    this.reportEnd = Date.UTC(year, month , 1);
    this.createGraph();
  }
  
  changeGraph(newGraphType: string) {
    

 
    this.graphType = newGraphType;
    this.displayGraphs();
  }

  
  createGraph() {
 
    this.savingsDays = Math.floor((this.reportEnd - this.reportStart) / 86400000 ); 
    
    let reportRequest = {
      room_id: this.roomId,
      start_timestamp: this.reportStart / 1000,
      end_timestamp: this.reportEnd / 1000
    }
        
    this.reportService.getLocationEnergySavings(this.roomId, reportRequest)
      .then(energySavingsResults => {
        
        this.energySavings = energySavingsResults;
        if (energySavingsResults.length !== 0 ) {
          
            this.savingsDataAvailable = true;
            this.roomName = this.energySavings[0].room_name;
            this.displayGraphs();
            
            this.automationHoursTotal = 0;
            this.energyUsedTotal = 0;
            this.energySavedTotal = 0;
          
            energySavingsResults.forEach(saving => {
                this.automationHoursTotal += saving.occupancyAutomationTime;
                this.energyUsedTotal += saving.totalkWh;
                this.energySavedTotal += saving.savings;
              }
            );
          let total = this.energySavedTotal / ( this.energyUsedTotal + this.energySavedTotal) * 100;
          this.energySavedPercentage =  Math.round((total + 0.00001) * 100) / 100;
          this.automationHoursTotal = Math.round((this.automationHoursTotal + 0.00001) * 100) / 100;
          this.energyUsedTotal = Math.round((this.energyUsedTotal + 0.00001) * 100) / 100;
          this.energySavedTotal = Math.round((this.energySavedTotal + 0.00001) * 100) / 100;
          
        } else {
            this.savingsDataAvailable = false;
        }
      })
  }
  
  private displayGraphs() {
    this.savingsReport(this.graphType);
    this.automationOnOff(this.graphType);
    this.airconOnOff(this.graphType);
    this.occupancyAutomationTime(this.graphType);
  }

  private savingsReport(graphType) {

    let xAxis = [];
    let series = [];
    let data = [];
    let totalData = [];

    for (let energySaving of this.energySavings) {
      let date = new Date(energySaving.timestamp * 1000);
      let dateStr = date.getDate() + '/' + (date.getMonth() + 1)

      xAxis.push(dateStr);
      data.push(energySaving.savings);
      totalData.push(energySaving.totalkWh);
    }

    series.push({
      name: 'Savings',
      data: data
    });

    series.push({
      name: 'Total kWh',
      data: totalData
    });


    this.options = {
      chart: {
        type: graphType
      },
      title: {
        text: 'Energy Savings vs Actual Consumption [' + this.roomName + ']'
      },
      subtitle: {
        text: 'Daily Energy Savings for the month of ...'
      },
      xAxis: {
        type: 'datetime',
        categories: xAxis,
        dateTimeLabelFormats: {
          month: '%e lol %b',
          year: '%b'
        },
        title: {
          text: 'Date'
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: 'kWh',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        }
      },
      tooltip: {
        valueSuffix: ' kWh'
      },
      credits: {
        enabled: false
      },
      series: series,
      exporting: {
        chartOptions: {
          plotOptions: {
            series: {
              groupPadding: 0,
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        fallbackToExportServer: false,
        buttons: {
          contextButton: {
            menuItems: ['printChart', 'downloadPNG', 'downloadCSV', 'downloadXLS']
          }
        }
      },
      rangeSelector: {
        inputPosition: {
          align: 'left',
          x: 0,
          y: 0
        },
        buttonPosition: {
          align: 'right',
          x: 0,
          y: 0
        },
      },
    };

    Highcharts.chart('savings', this.options);
  }

  
  private automationOnOff(graphType) {

    let xAxis = [];
    let series = [];
    let data = [];
    let totalData = [];

    for (let energySaving of this.energySavings) {
      let date = new Date(energySaving.timestamp * 1000);
      let dateStr = date.getDate() + '/' + (date.getMonth() + 1)

      xAxis.push(dateStr);
      data.push(energySaving.acitve_hours);
      totalData.push(energySaving.inacitve_hours);
    }

    series.push({
      name: 'Active',
      data: data
    });

    series.push({
      name: 'Inactive',
      data: totalData
    });


    this.options = {
      chart: {
        type: graphType
      },
      title: {
        text: 'Automation On Off [' + this.roomName + ']'
      },
      subtitle: {
        text: 'Hours of automation on'
      },
      xAxis: {
        type: 'datetime',
        categories: xAxis,
        dateTimeLabelFormats: {
          month: '%e lol %b',
          year: '%b'
        },
        title: {
          text: 'Date'
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Duration (h)',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        }
      },
      tooltip: {
        valueSuffix: ' hours'
      },
      credits: {
        enabled: false
      },
      series: series,
      exporting: {
        chartOptions: {
          plotOptions: {
            series: {
              groupPadding: 0,
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        fallbackToExportServer: false,

        buttons: {
          contextButton: {
            menuItems: ['printChart', 'downloadPNG', 'downloadCSV', 'downloadXLS']
          }
        }
      },
      rangeSelector: {
        inputPosition: {
          align: 'left',
          x: 0,
          y: 0
        },
        buttonPosition: {
          align: 'right',
          x: 0,
          y: 0
        },
      },
    };

    Highcharts.chart('automation', this.options);
  }
  
  
  private airconOnOff(graphType) {

    let xAxis = [];
    let series = [];
    let data = [];
    let totalData = [];

    for (let energySaving of this.energySavings) {
      let date = new Date(energySaving.timestamp * 1000);
      let dateStr = date.getDate() + '/' + (date.getMonth() + 1)

      xAxis.push(dateStr);
      data.push(energySaving.aircon_on);
      totalData.push(energySaving.aircon_off);
    }

    series.push({
      name: 'On',
      data: data
    });

    series.push({
      name: 'Off',
      data: totalData
    });


    this.options = {
      chart: {
        type: graphType
      },
      title: {
        text: 'Aircon On Off [' + this.roomName + ']'
      },
      subtitle: {
        text: 'Hours of aircon on and off'
      },
      xAxis: {
        type: 'datetime',
        categories: xAxis,
        dateTimeLabelFormats: {
          month: '%e lol %b',
          year: '%b'
        },
        title: {
          text: 'Date'
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Duration (h)',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        }
      },
      tooltip: {
        valueSuffix: ' hours'
      },
      credits: {
        enabled: false
      },
      series: series,
      exporting: {
        chartOptions: {
          plotOptions: {
            series: {
              groupPadding: 0,
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        fallbackToExportServer: false,

        buttons: {
          contextButton: {
            menuItems: ['printChart', 'downloadPNG', 'downloadCSV', 'downloadXLS']
          }
        }
      },
      rangeSelector: {
        inputPosition: {
          align: 'left',
          x: 0,
          y: 0
        },
        buttonPosition: {
          align: 'right',
          x: 0,
          y: 0
        },
      },
    };

    Highcharts.chart('aircon_on_off', this.options);
  }
  
    private occupancyAutomationTime(graphType) {

    let xAxis = [];
    let series = [];
    let data = [];

    for (let energySaving of this.energySavings) {
      let date = new Date(energySaving.timestamp * 1000);
      let dateStr = date.getDate() + '/' + (date.getMonth() + 1)

      xAxis.push(dateStr);
      data.push(energySaving.occupancyAutomationTime);
    }

    series.push({
      data: data
    });

    /*
    this.options = {
      chart: {
        type: graphType
      },
      title: {
        text: 'occupancyAutomationTime [' + this.roomName + ']'
      },
      subtitle: {
        text: 'Hours of automation through occupancy'
      },
      xAxis: {
        type: 'datetime',
        categories: xAxis,
        dateTimeLabelFormats: {
          month: '%e lol %b',
          year: '%b'
        },
        title: {
          text: 'Date'
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Duration (h)',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        }
      },
      tooltip: {
        valueSuffix: ' hours'
      },
      credits: {
        enabled: false
      },
      series: series,
      exporting: {
        chartOptions: {
          plotOptions: {
            series: {
              groupPadding: 0,
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        fallbackToExportServer: false,

        buttons: {
          contextButton: {
            menuItems: ['printChart', 'downloadPNG', 'downloadCSV', 'downloadXLS']
          }
        }
      },
      rangeSelector: {
        inputPosition: {
          align: 'left',
          x: 0,
          y: 0
        },
        buttonPosition: {
          align: 'right',
          x: 0,
          y: 0
        },
      },
    };
    */

    //Highcharts.chart('occupancyAutomationTime', this.options);
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/reports/report.component.ts